import { render, staticRenderFns } from "./CustomLoading.vue?vue&type=template&id=99a68d9c&"
import script from "./CustomLoading.vue?vue&type=script&lang=js&"
export * from "./CustomLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports